
const visibleLayers = [`zcm:0100_ce_limites_municipais_2025_pol`];

function geoCSVReader(resource, geoWorkspace, serverURL, serverType) {
  const tree = [];
  const layers = [];
  const rows = resource.split('\n').filter(Boolean);

  const _visible = visibleLayers
    ? visibleLayers
    : [];

  for (const row of rows) {
    const data = row.split(';');

    const titles = [data[1], data[2], data[3], data[4]].map(s => (s ?? '').trim());
    const lastNonEmptyLevel = Math.max(...titles.map((t, i) => (t ? i : -1)));

    const folderSequence = titles.filter(Boolean).join('_');

    ensurePathCompatible(tree, titles, lastNonEmptyLevel);

    const show = (data[10] ?? '').trim() === 'Sim';
    if (show) {
      const wmsRaw = (data[5] ?? '').trim();
      const wmsName = `${geoWorkspace}:${wmsRaw.toLowerCase()}`;

      layers.push({
        wmsName,
        title: (data[6] ?? '').trim(),
        folder: lastNonEmptyLevel >= 0 ? titles[lastNonEmptyLevel] : '',
        folderSequence,
        url: serverURL,
        visibility: _visible.includes(wmsName),
        queryable: true,
        serverType,
        isAllowedToStatistics: (data[9] ?? '').trim() === 'Sim',
        bbox: data[11],
        attributes: data[12],
        geomType: data[13]
      });
    }
  }

  return { tree, layers };
}


function ensurePathCompatible(rootArray, titles, lastNonEmptyLevel) {
  let currentArray = rootArray;

  if (lastNonEmptyLevel < 0) return;

  for (let i = 0; i <= lastNonEmptyLevel; i++) {
    const title = (titles[i] ?? '').trim();
    if (!title) break;

    let idx = currentArray.findIndex(n => n.title === title);
    if (idx === -1) {
      const isLast = (i === lastNonEmptyLevel);
      currentArray.push({
        title,
        folderSequence: titles.slice(0, i + 1).filter(Boolean).join('_'),
        subFolder: isLast ? null : [] 
      });
      idx = currentArray.length - 1;
    } else {
      currentArray[idx].folderSequence = titles.slice(0, i + 1).filter(Boolean).join('_');

      const goingDeeper = i < lastNonEmptyLevel;
      if (goingDeeper && currentArray[idx].subFolder === null) {
        currentArray[idx].subFolder = []; 
      }
      if (!('subFolder' in currentArray[idx])) {
        currentArray[idx].subFolder = goingDeeper ? [] : null;
      }
    }

    const node = currentArray[idx];
    if (i < lastNonEmptyLevel) {
      if (!Array.isArray(node.subFolder)) node.subFolder = [];
      currentArray = node.subFolder;
    }
  }
}


/*
function geoCSVReader(resource, geoWorkspace, serverURL, serverType) {

    let tree = [];
    let layers = [];
    let rows = resource.split('\n');
    
    rows.map(row => {
        let data = row.split(';');
        let folderSequence = data[1];
        let layerLevel = 1;
        let category_id = populateTree(tree, data[1], folderSequence, data[2]!=='');
        
        if (data[2]) {
            folderSequence+=`_${data[2]}`;
            let major_class_id = populateTree(tree[category_id].subFolder, data[2], folderSequence,data[3]!=='');
            layerLevel++;
            if (data[3]) {
                folderSequence+=`_${data[3]}`;
                let sub_class_id = populateTree(tree[category_id].subFolder[major_class_id].subFolder, data[3], folderSequence, data[4]!=='');
                layerLevel++;
                if (data[4]){
                    folderSequence+=`_${data[4]}`;
                    populateTree(tree[category_id].subFolder[major_class_id].subFolder[sub_class_id].subFolder, data[4], folderSequence, false);
                    layerLevel++;
                }
            }
            
        }

        if(data[10] && data[10] === `Sim`)
            layerInclude(layers, geoWorkspace + ':' + data[5].toLowerCase(), data[6], data[layerLevel], folderSequence, serverURL, serverType, data[9] && data[9] === `Sim`, data[11], data[12], data[13]);
        
        return true;
    }
    );

    return { tree, layers };

}

function populateTree(object, title, folderSequence, hasSubFolder = true) {
    try{
        if (title && object && !object.find(e => e.title === title)) {
            object.push({ title, folderSequence, subFolder: hasSubFolder ? [] : null })
        }
        return  object && object.findIndex(e => e.title === title) >= 0 ? object.findIndex(e => e.title === title) : 0;
    }catch(e){
        console.log('title '+ title)
        return 0;
    }
}

function layerInclude(object, wmsName, title, folder, folderSequence, url, serverType, isAllowedToStatistics, bbox, attributes, geomType) {
    
    let visibility = (visibleLayers.find(layer=>layer===wmsName))?true:false;

    object.push({ wmsName, title, folder, folderSequence, url, visibility, queryable: true, serverType, isAllowedToStatistics, bbox, attributes, geomType })

}
*/

export default geoCSVReader;